import { render, staticRenderFns } from "./pencil_tool.vue?vue&type=template&id=4f0d8363"
import script from "./pencil_tool.vue?vue&type=script&lang=js"
export * from "./pencil_tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports